import {useEffect, useMemo, useState,} from "react";
import MarketingContext from "./MarketingContext.js";
import {useIsMount} from "../../hooks/useIsMount.js";


const MarketingContextProvider = ({children}) => {
    const isMount = useIsMount();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (!isMount) return

        const init = async () => {
            setIsReady(true);
        }

        init();
    }, []);

    const context = useMemo(
        () => ({
            isReady,
        }),
        [
            isReady,
        ]
    );
    return (
        <MarketingContext.Provider value={context}>{children}</MarketingContext.Provider>
    );
};
export default MarketingContextProvider;
